import { useEffect, useState } from 'react';
import { useDataStore } from './stores/dataStore';

// Shared source of truth for students with realtime updates
export function useStudents(options = { orderByLastName: true, ensureSubscription: false }) {
  const storeStudents = useDataStore((s) => s.students);
  const studentsLoading = useDataStore((s) => s.studentsLoading);
  const studentsError = useDataStore((s) => s.studentsError);
  const subscribeStudents = useDataStore((s) => s.subscribeStudents);

  // Optionally ensure subscription if explicitly requested
  useEffect(() => {
    if (!options.ensureSubscription) return;
    const unsub = subscribeStudents();
    return () => { try { unsub && unsub(); } catch { /* noop */ } };
  }, [subscribeStudents, options.ensureSubscription]);

  // Sorting handled in store; preserve API for option
  const [students, setStudents] = useState(storeStudents);
  useEffect(() => {
    if (options.orderByLastName) {
      setStudents([...storeStudents]);
    } else {
      // If caller doesn't want sorting, return as-is
      setStudents(storeStudents);
    }
  }, [storeStudents, options.orderByLastName]);

  return { students, loading: studentsLoading, error: studentsError };
}
